import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import {
  Box,
  Paper,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import Otp from "../otp";
import QrCode from "../qrCode";
import LoginForms from "./forms";
function Login() {
  const isMd = useMediaQuery("(min-width:756px)");
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  return (
    <>
      <Box
        sx={{
          display: { md: "flex" },
          alignItems: "start",
          justifyContent: "center",
          width: "100%",
          height: { md: "100vh", xs: "100%" },
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          minHeight: "100vh",
        }}
        className="errorInput relative md:py-0 pt-4 pb-7 bg-white "
      >
        {themeDisplay === "blue" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/2-01.svg"
            alt=""
          />
        ) : themeDisplay === "green" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/3-01.svg"
            alt=""
          />
        ) : themeDisplay === "orange" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/4-01.svg"
            alt=""
          />
        ) : themeDisplay === "dark" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/5-01.svg"
            alt=""
          />
        ) : (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/1-01.svg"
            alt=""
          />
        )}

        <Box
          sx={{ height: "100%" }}
          className="flex  flex-col  gap-4 justify- mt-2"
        >
          <Box
            sx={{ height: { md: "auto", xs: "auto" }, width: "100%" }}
            className="flex  flex-col items-center justify-center loginTab"
          >
            <Paper
              elevation={0}
              sx={{
                width: { md: "650px", xs: "95%" },
                zIndex: { md: 1 },
                bgcolor: {
                  md:
                    themeDisplay === "dark"
                      ? "#5790c8"
                      : themeDisplay === "blue"
                      ? "#3b5396"
                      : themeDisplay === "green"
                      ? "#03765b"
                      : themeDisplay === "orange"
                      ? "#f99f04"
                      : "#725EDA",
                },
                mt: { md: 10 },
                pb: { md: 1 },
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label=" ورود با نام کاربری" {...a11yProps(0)} />
                <Tab
                  className="middle"
                  label=" ورود با کد یکبار مصرف"
                  {...a11yProps(1)}
                />
                <Tab label=" ورود با QR" {...a11yProps(2)} />
              </Tabs>
              <Box
                sx={{
                  flexDirection: "column-reverse",
                  display: { md: "grid", xs: "flex" },
                  gridTemplateColumns: { md: "1fr 1fr 1fr" },
                }}
              >
                <Box className="col-span-2 md:min-h-[540px]">
                  <SwipeableViews
                    axis={"x-reverse"}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                    dir="rtl"
                  >
                    <TabPanel dir={"rtl"} value={value} index={0}>
                      <LoginForms />
                    </TabPanel>
                    <TabPanel dir={"rtl"} value={value} index={1}>
                      <Otp handleBack={() => setValue(0)} />
                    </TabPanel>
                    <TabPanel dir={"rtl"} value={value} index={2}>
                      <QrCode
                        handleBack={() => setValue(0)}
                        active={value === 2}
                      />
                    </TabPanel>
                  </SwipeableViews>
                </Box>
                {/* liste sefid */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: "300px",
                    gap: { md: 3, xs: 1 },
                    pt: 1,
                  }}
                >
                  {isMd && (
                    <>
                      <div className="bg-white flex items-center rounded-md justify-center p-2">
                        <img
                          src="/assets/images/logo.png"
                          alt=""
                          className="md:w-[130px] w-[50px]"
                        />
                      </div>

                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                          justifyContent: "space-between",
                          mr: 2,
                        }}
                      >
                        <SupportAgentIcon sx={{ color: "#fff" }} />
                        <div className="flex flex-col items-end gap-1">
                          <Typography
                            component={"a"}
                            href={`tel:${process.env.REACT_APP_TEL1}`}
                            sx={{
                              fontSize: "1rem",
                              color: "#fff",
                              fontWeight: "bold",
                            }}
                          >
                            {process.env.REACT_APP_TEL1}
                          </Typography>{" "}
                          <Typography
                            component={"a"}
                            href={`tel:${process.env.REACT_APP_TEL2}`}
                            sx={{
                              fontSize: "1rem",
                              color: "#fff",
                              fontWeight: "bold",
                              /*                         ml:"90px"
                               */
                            }}
                          >
                            {process.env.REACT_APP_TEL2}
                          </Typography>
                        </div>
                      </Box>
                      {/*   <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 1,
                      }}
                    >
                      <img
                        src="/assets/images/login/logo.png"
                        alt=""
                        className="w-[2rem]"
                      />
                    </Box> */}
                    </>
                  )}
                </Box>
              </Box>
            </Paper>
          </Box>
          {!isMd && (
            <div className="flex flex-col pb-5 justify-center items-center  ">
              {" "}
              <Box
                className=" "
                sx={{ display: "flex", gap: 1, alignItems: "center" }}
              >
                <SupportAgentIcon sx={{ color: "#20a8d8" }} />
                <div className="flex flex-col items-end gap-1">
                  <Typography
                    component={"a"}
                    href={`tel:${process.env.REACT_APP_TEL1}`}
                    sx={{
                      fontSize: "1rem",
                      color: "#20a8d8",
                      fontWeight: "bold",
                    }}
                  >
                    {process.env.REACT_APP_TEL1}
                  </Typography>{" "}
                  <Typography
                    component={"a"}
                    href={`tel:${process.env.REACT_APP_TEL2}`}
                    sx={{
                      fontSize: "1rem",
                      color: "#20a8d8",
                      fontWeight: "bold",
                      /*                         ml:"90px"
                       */
                    }}
                  >
                    {process.env.REACT_APP_TEL2}
                  </Typography>
                </div>
              </Box>
            </div>
          )}
        </Box>
        {/* 
        <Link className="absolute md:block hidden top-2 left-2" to="/">
          <img
            src="/assets/images/logo.png"
            alt=""
            className="md:w-[130px] w-[50px]"
          />
        </Link> */}
      </Box>
    </>
  );
}

export default Login;
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <>{children}</>
        </>
      )}
    </div>
  );
}
